import { Tooltip } from "antd";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { kFormatter } from "../../../redux/constants";
import { CaretUpFilled, CaretDownFilled } from "@ant-design/icons";
const TicketOverviewcards = ({
  cardPosition,
  cardsData,
  type,
  filterTime,
  widget_id,
  setSelectedWidget,
  selectedWidget,
  graph_type,
  setGraphLoader,
}) => {
  const authParams = useSelector((state) => state.Authentication.authParams);

  const secondsToDhms = (seconds) => {
    seconds = Number(seconds);
    var d = Math.floor(seconds / (3600 * 24));
    var h = Math.floor((seconds % (3600 * 24)) / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor(seconds % 60);

    var dDisplay = d > 0 ? d + (d === 1 ? " D, " : " D, ") : "";
    var hDisplay = h > 0 ? h + (h === 1 ? " h, " : " h, ") : "";
    var mDisplay = m > 0 ? m + (m === 1 ? " m, " : " m, ") : "";
    var sDisplay = s > 0 ? s + (s === 1 ? " s" : " s") : "";
    return dDisplay + hDisplay + mDisplay + sDisplay;
  };
  const handleChangeWidget = (data) => {
    setSelectedWidget(data);
    setGraphLoader(true);
  };
  return (
    <div
      className={`d-flex flex-wrap w-100 wm-chart-cards justify-content-between ${
        (cardPosition && cardPosition === "Left") || cardPosition === "Right"
          ? "custom_scroll1 card__list--scrollable"
          : ""
      }`}
      style={
        type === "map"
          ? { maxHeight: "calc(100vh - 16.5rem)" }
          : widget_id === "tickets_overview_1" ||
            widget_id === "tickets_overview_2"
          ? { maxHeight: "45rem" }
          : {}
      }
    >
      {cardsData?.map((data) => {
        return (
          <div
            className={`portlet1 border-color border pt-4 pb-4 text-center ${
              widget_id === "tickets_overview_2" ? "cursor-pointer" : ""
            } ${
              (cardPosition && cardPosition === "Left") ||
              (cardPosition && cardPosition === "Right")
                ? "wm-chart-cards-left w-100"
                : ""
            }`}
            style={
              widget_id === "tickets_overview_2"
                ? selectedWidget === data?.text
                  ? {
                      boxShadow: "0 0 0.6rem " + "#57e2cf" + "10",
                      //borderLeft: "1.5rem solid "+data?.color,
                      // border: "0.1rem solid " + "#57e2cf" + "80",
                      backgroundColor: "#57e2cf" + "50",
                      pointerEvents: "none",
                      // borderRadius: "0.4rem",
                      //color: "#",
                    }
                  : {
                      boxShadow: "0 0 0.6rem #c3cbd710",
                      // borderRadius: "0.4rem",
                      // border:
                      //   authParams?.theme_type === "1"
                      //     ? "0.1rem solid transparent"
                      //     : "0.1rem solid #c3cbd7",
                      // backgroundColor:
                      //   authParams?.theme_type === "1" ? "" : "#f9f9f9",
                    }
                : data?.color && data?.color?.trim() !== "#000000"
                ? {
                    boxShadow: "0 0 0.6rem " + data?.color?.trim() + "10",
                    flex: graph_type === "number" ? "1 0 calc(25% - 3rem)" : "",
                    //borderLeft: "1.5rem solid "+data?.color,
                    // border: "0.1rem solid " + data?.color?.trim() + "80",
                    backgroundColor: data?.color?.trim() + "30",
                    //pointerEvents: "none",
                    // borderRadius: "0.4rem",
                    //color: "#",
                  }
                : data?.text === "Avg Respond Time Within Benchmark" ||
                  data?.text === "Avg Respond Time Beyond Benchmark"
                ? {
                    boxShadow:
                      "0 0 0.6rem " +
                      (data?.value > filterTime ? "#dc3545" : "#aee256") +
                      "10",
                    //borderLeft: "1.5rem solid "+data?.color,
                    // border:
                    //   "0.1rem solid " +
                    //   (data?.value > filterTime ? "#dc3545" : "#aee256") +
                    //   "50",
                    // backgroundColor:
                    //   (data?.value > filterTime ? "#dc3545" : "#aee256") +
                    //   "30",
                    // borderRadius: "0.4rem",
                  }
                : {
                    boxShadow: "0 0 0.6rem #c3cbd710",
                    // borderRadius: "0.4rem",
                    // border:
                    //   authParams?.theme_type === "1"
                    //     ? "0.1rem solid transparent"
                    //     : "0.1rem solid #c3cbd7",
                    // backgroundColor:
                    //   authParams?.theme_type === "1" ? "" : "#f9f9f9",
                  }
            }
            onClick={
              widget_id === "tickets_overview_2"
                ? () => handleChangeWidget(data?.text)
                : null
            }
          >
            <div
              //style={{ minHeight: "3.3rem" }}
              className="wm-chart-card-title mb-1 line-height-normal"
            >
              <Tooltip
                //title={data?.value ? data?.value : "0"}
                title={data?.text}
                placement="topLeft"
                className="text-ellipsis d-inline-block"
              >
                {data?.text?.length >= 40
                  ? `${data?.text.substring(0, 40)}...`
                  : data?.text}
                {/* {data?.value ? kFormatter(data?.value) : "0"} */}
              </Tooltip>
              {data?.info_help_text && (
                <Tooltip
                  title={data?.info_help_text}
                  placement="top"
                  className="text-ellipsis d-inline-block"
                >
                  <i className="fa fa-question-circle cursor-pointer ml-1" />
                </Tooltip>
              )}
              {data?.info_text && (
                <Tooltip
                  title={data?.info_text}
                  placement="top"
                  className="text-ellipsis d-inline-block"
                >
                  <i className="fa fa-info-circle cursor-pointer ml-1" />
                </Tooltip>
              )}
            </div>
            <div className="d-flex align-items-baseline justify-content-center flex-wrap">
              <span className="wm-chart-card-value mr-1">
                {data?.value ? (
                  data?.text === "Avg Respond Time Within Benchmark" ||
                  data?.text === "Avg Respond Time Beyond Benchmark" ? (
                    secondsToDhms(data?.value)
                  ) : (
                    <Tooltip
                      placement="bottom"
                      title={data?.value?.toLocaleString()}
                    >
                      {kFormatter(data?.value)}
                    </Tooltip>
                  )
                ) : (
                  "0"
                )}
              </span>
              {data?.percent_change ? (
                <span
                  className={`text_regular ${
                    data?.percent_change === 0 ? "d-flex" : "d-flex"
                  } align-items-baseline ${
                    String(data?.text).toLowerCase() ===
                    String("Negative").toLowerCase()
                      ? data?.percent_change > 0
                        ? "negative"
                        : data?.percent_change < 0
                        ? "positive"
                        : "text-gray"
                      : data?.percent_change > 0
                      ? "positive"
                      : data?.percent_change < 0
                      ? "negative"
                      : "text-gray"
                  } font-size12 font-weight600`}
                >
                  {data?.percent_change > 0 ? (
                    <>
                      <CaretUpFilled className="font-size18" />
                      {" " +
                        Number(data?.percent_change)?.toLocaleString() +
                        "%"}
                    </>
                  ) : data?.percent_change < 0 ? (
                    <>
                      <CaretDownFilled className="font-size18" />
                      {" " +
                        Number(data?.percent_change)?.toLocaleString() +
                        "%"}
                    </>
                  ) : (
                    "NA"
                  )}{" "}
                </span>
              ) : (
                ""
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default TicketOverviewcards;
